"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainShader = void 0;
const fragmentSrc = `#ifdef GL_ES
precision highp float;
#endif

uniform sampler2D diffuse;
uniform sampler2D lightmap;
uniform float opacity;

varying vec2 vTexCoord;
varying vec2 vLightmapCoord;

void main(void) {
  vec4 diffuseColor = texture2D(diffuse, vTexCoord);
  vec4 lightColor = texture2D(lightmap, vLightmapCoord);

  gl_FragColor = vec4(diffuseColor.rgb * lightColor.rgb, diffuseColor.a * opacity);
}`;
const vertexSrc = `#ifdef GL_ES
precision highp float;
#endif

attribute vec3 position;
attribute vec2 texCoord;
attribute vec2 texCoord2;

varying vec2 vTexCoord;
varying vec2 vLightmapCoord;

uniform mat4 modelMatrix;
uniform mat4 viewMatrix;
uniform mat4 projectionMatrix;

void main(void) {
  vTexCoord = texCoord;
  vLightmapCoord = texCoord2;

  gl_Position = projectionMatrix * viewMatrix * modelMatrix * vec4(position, 1);
}`;
class MainShader {
    static init(context) {
        const attributeNames = ['position', 'texCoord', 'texCoord2'];
        const uniformNames = [
            'modelMatrix',
            'viewMatrix',
            'projectionMatrix',
            'diffuse',
            'lightmap',
            'opacity'
        ];
        const program = context.createProgram({
            vertexShaderSrc: vertexSrc,
            fragmentShaderSrc: fragmentSrc,
            attributeNames,
            uniformNames
        });
        if (!program) {
            console.error('Failed to create MainShader program');
            return null;
        }
        return new MainShader(program);
    }
    constructor(program) {
        this.program = program.handle;
        this.aPosition = program.attributes['position'];
        this.aTexCoord = program.attributes['texCoord'];
        this.aTexCoord2 = program.attributes['texCoord2'];
        this.uModelMx = program.uniforms['modelMatrix'];
        this.uViewMx = program.uniforms['viewMatrix'];
        this.uProjectionMx = program.uniforms['projectionMatrix'];
        this.uDiffuse = program.uniforms['diffuse'];
        this.uLightmap = program.uniforms['lightmap'];
        this.uOpacity = program.uniforms['opacity'];
    }
    useProgram(gl) {
        gl.useProgram(this.program);
    }
    setModelMatrix(gl, matrix) {
        gl.uniformMatrix4fv(this.uModelMx, false, matrix);
    }
    setViewMatrix(gl, matrix) {
        gl.uniformMatrix4fv(this.uViewMx, false, matrix);
    }
    setProjectionMatrix(gl, matrix) {
        gl.uniformMatrix4fv(this.uProjectionMx, false, matrix);
    }
    setDiffuse(gl, value) {
        gl.uniform1i(this.uDiffuse, value);
    }
    setLightmap(gl, val) {
        gl.uniform1i(this.uLightmap, val);
    }
    setOpacity(gl, val) {
        gl.uniform1f(this.uOpacity, val);
    }
    enableVertexAttribs(gl) {
        gl.enableVertexAttribArray(this.aPosition);
        gl.enableVertexAttribArray(this.aTexCoord);
        gl.enableVertexAttribArray(this.aTexCoord2);
    }
    setVertexAttribPointers(gl) {
        gl.vertexAttribPointer(this.aPosition, 3, gl.FLOAT, false, 7 * 4, 0);
        gl.vertexAttribPointer(this.aTexCoord, 2, gl.FLOAT, false, 7 * 4, 3 * 4);
        gl.vertexAttribPointer(this.aTexCoord2, 2, gl.FLOAT, false, 7 * 4, 5 * 4);
    }
}
exports.MainShader = MainShader;
